import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import NewsBanner from "../../assets/images/image-1920x720.jpg";
import {
  formatNewsDate,
  getArticleImage,
  getVideoEmbedUrl,
  useNews,
  useNewsArticle,
} from "../../http/useNews";
import { NewsCard } from "./components/NewsCard";

export const NewsDetails = () => {
  const { id } = useParams();
  const { t, i18n } = useTranslation();
  const { data: articleData, isLoading, isError } = useNewsArticle(id);
  const { data: newsData } = useNews();

  // Unknown ids come back as an empty article with `id: null`, not a 404.
  const article = articleData?.article?.id ? articleData.article : null;
  const related = newsData?.articles?.filter((item) => item.id !== id).slice(0, 3);
  const videoUrl = getVideoEmbedUrl(article?.path);
  const heroImage = getArticleImage(article);
  const notFound = !isLoading && (isError || !article);

  return (
    <div>
      {videoUrl ? (
        // The video is the cover: player on a dark backdrop of the blurred article image
        <section className="NewsVideoHero">
          <div
            className="NewsVideoHero-backdrop"
            style={{ backgroundImage: `url(${heroImage ?? NewsBanner})` }}
          />
          <div className="container position-relative">
            <span className="NewsVideoHero-date">
              {formatNewsDate(article.date, i18n.language)}
            </span>
            <h1>{article.name}</h1>
            <div className="NewsDetails-video">
              <iframe
                src={videoUrl}
                title={article.name}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
        </section>
      ) : (
        <section
          className={`Banner NewsBanner${heroImage ? " has-image" : ""}`}
          style={{ backgroundImage: `url(${heroImage ?? NewsBanner})` }}
        >
          <div className="ovelay"></div>
          <div className="container position-relative">
            <h1 className="text-white" data-aos="fade-up">
              {article?.name ?? newsData?.articleType?.name}
            </h1>
          </div>
        </section>
      )}

      <section className="NewsDetails py-5">
        <div className="container">
          {notFound ? (
            <div className="text-center py-5">
              <h3>{t("News-Not-Found")}</h3>
              <Link to="/news" className="GreenButton mt-3">
                {t("All-News")}
              </Link>
            </div>
          ) : (
            article && (
              <div className="row">
                <div className="col-lg-10 m-auto">
                  {!videoUrl && (
                    <span className="NewsCard-date">
                      {formatNewsDate(article.date, i18n.language)}
                    </span>
                  )}
                  <div
                    className="news-content"
                    dangerouslySetInnerHTML={{ __html: article.description }}
                  />
                </div>
              </div>
            )
          )}

          {article && related?.length > 0 && (
            <div className="mt-5">
              <h2 className="mb-3">{t("Related-News")}</h2>
              <div className="row">
                {related.map((item) => (
                  <div className="col-md-4 my-3" key={item.id}>
                    <NewsCard article={item} />
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};
